<template>
  <div id="systemUpdates_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            系統公告列表
          </div>
          <div class="tip">
            可檢視所有系統公告、公告刊登時間與最新狀態。
          </div>
        </div>
      </div>
      <el-table
        class="systemUpdateslist"
        :data="listData"
        :cell-class-name="tableCellClassName"
      >
        <el-table-column
          type="index"
          align="center"
          width="50"
        />
        <el-table-column
          align="left"
          label="公告標題"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.IsNew"
              type="danger"
            >
              New
            </el-tag>
            <span
              v-if="scope.row.Title != ''"
              class="list-title"
              @click="goDetailPage(scope.row.Id)"
            >{{ scope.row.Title }}</span>
            <span
              v-else
              class="list-title"
              @click="goDetailPage(scope.row.Id)"
            >無</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateDate"
          align="left"
          label="公告日期"
          width="400"
        />
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'

export default {
  components: {
    TableLoading
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$store.state.systemUpdates.height !== null) {
        vm.$nextTick(() => {
          document.documentElement.scrollTop = vm.$store.state.systemUpdates.height
        })
      }
    })
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== 'SystemUpdatesDetail') { this.$store.commit('recordSystemUpdatesHeight', null) }
    next()
  },
  data () {
    return {
      listData: [],
      offset: 0,
      stopGetList: true,
      loading: false
    }
  },
  mounted () {
    this.getList()
    window.addEventListener('scroll', this.autoShow, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
  },
  methods: {
    getList () {
      this.loading = true
      const requestData = {
        'PageParam.Offset': this.offset,
        'PageParam.MaxCount': 10
      }
      return apiSystem.GetSystemList(
        requestData
      ).then(async (res) => {
        if (res.data.Status === 1) {
          this.stopGetList = !(res.data.Data.length < 10)
          res.data.Data.forEach(item => {
            item.CreateDate = (item.CreateDate != null) ? item.CreateDate.slice(0, 16) : ''
          })
          await this.$sleep(1000)
          this.listData = this.listData.concat(res.data.Data)
        } else {
          console.log('錯誤，res.data.Status' + res.data.Status)
        }
        this.loading = false
        return true
      }).catch((err) => {
        console.log('錯誤訊息：' + err.response)
        return false
      })
    },
    goDetailPage (id) {
      console.log(id)
      this.$store.commit('recordSystemUpdatesHeight', document.documentElement.scrollTop)
      this.$router.push({ name: 'SystemUpdatesDetail', params: { id } })
    },
    // 下拉到底自動載入
    autoShow () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'SystemUpdates') {
        if (!this.scrollEnd && this.stopGetList) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    },
    tableCellClassName ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) { return 'table1' }
      if (columnIndex === 2) { return 'table2' }
    }
  }
}
</script>

<style lang="sass" scoped>
#systemUpdates_main
  +mainLayer
  .systemUpdateslist
    font-size: 15px
    .list-title
      cursor: pointer
      color: $mainColorDark
      text-decoration: underline
  ::v-deep .el-table
    +basicTable
    .el-tag
      font-weight: bold
      margin-right: 20px

</style>
